// Ключ `GET /api/friends` без параметров (ключи `$api` — `[method, path, init]`): по нему
// перечитываются все периоды сразу — после события `friends.updated` и смены видимости.
export const FRIENDS_QUERY_KEY = ["get", "/api/friends"] as const;
